import { Component } from '@angular/core';
import {NavBarComponent} from "../nav-bar/nav-bar.component";
import {FooterPersonaComponent} from "../footer-persona/footer-persona.component";
import {AllLaboratorioComponent} from "./all-laboratorio/all-laboratorio.component";

@Component({
  selector: 'app-laboratorio',
  standalone: true,
  imports: [
    NavBarComponent,
    FooterPersonaComponent,
    AllLaboratorioComponent
  ],
  templateUrl: './laboratorio.component.html',
  styleUrl: './laboratorio.component.css'
})
export class LaboratorioComponent {

}
